import { motion } from "framer-motion";
import { CheckCircle2Icon } from "lucide-react";
import { CtaButton } from "./CtaButton";
const stats = [{
  n: "+250",
  l: "Protocolos Clínicos"
}, {
  n: "6",
  l: "Tomos Especializados"
}, {
  n: "+50",
  l: "Herramientas y Recursos"
}, {
  n: "100%",
  l: "Acceso Digital Inmediato"
}];
const badges = ["Descarga inmediata", "Pago único", "Acceso de por vida", "Garantía de 7 días"];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#0f2547] text-white" data-id="element-120" data-mp="127ef5fynvtei">
      {/* backdrop glow */}
      <div className="pointer-events-none absolute inset-0" data-id="element-121" data-mp="x8jndoipuui9">
        <div className="absolute -top-32 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-[#2196f3]/25 blur-[100px]" data-id="element-122" data-mp="s9zxxe4wz0l5" />
        <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-[#1e88e5]/15 blur-[90px]" data-id="element-123" data-mp="nbydopvr4v83" />
      </div>

      <div className="relative mx-auto max-w-lg px-5 pb-10 pt-9 sm:max-w-2xl sm:pt-12 lg:max-w-5xl" data-id="element-124" data-mp="3cz5vmcnsk20v">
        {/* logo / brand */}
        <div className="mb-6 flex items-center justify-center gap-2" data-id="element-125" data-mp="3j7zhzqi0g6kd">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 ring-1 ring-white/15" data-id="element-126" data-mp="3j6o8da1vw4lc">
            <svg viewBox="0 0 24 24" className="h-5 w-5 fill-[#2196f3]" data-id="element-127" data-mp="39al9cd2bwm2m">
              <path d="M12 2c-2 0-3 1-4.5 1S5 2 4 3.5 3 8 4 12s1.5 8 3 8 1.5-4 3-4 1.5 4 3 4 2-4 3-8 1-7 0-8.5S15 3 13.5 3 14 2 12 2z" data-id="element-128" data-mp="39cpcutwbfj2d" />
            </svg>
          </span>
          <span className="font-head text-sm font-800 uppercase tracking-[0.2em] text-white/80" data-id="element-129" data-mp="30ggdtgc92mgr">
            Dra. Karito
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-130" data-mp="2qk3muq83ampp">
          <div className="mx-auto mb-4 inline-flex items-center gap-2 rounded-full border border-[#2196f3]/40 bg-[#2196f3]/10 px-3 py-1 text-xs font-600 text-[#8ec9ff]" data-id="element-131" data-mp="2hj5ddsevtmzq">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#2196f3]" data-id="element-132" data-mp="2ljz0ijki2xrk" />
            Sistema Clínico Probado
          </div>

          <h1 className="font-head text-[28px] font-800 leading-[1.1] sm:text-4xl lg:text-5xl" data-id="element-133" data-mp="nbl4urpxgsdm">
            Sistema Maestro de{" "}
            <span className="bg-gradient-to-r from-[#2196f3] via-[#8ec9ff] to-[#2196f3] bg-clip-text text-transparent animate-shine" data-id="element-134" data-mp="id9tgcjzi9ta">
              Planificación con Alineadores
            </span>
            <span className="align-super text-base" data-id="element-135" data-mp="1azumdhg3ytyy">™</span>
          </h1>

          <p className="mx-auto mt-4 max-w-xl text-[15px] font-500 leading-relaxed text-white/75 sm:text-lg" data-id="element-136" data-mp="161ay3ae1l63f">
            Deja de improvisar cada planificación y sigue un sistema clínico
            probado para diagnosticar, planificar y finalizar casos con mayor
            seguridad y confianza.
          </p>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/55 sm:text-base" data-id="element-137" data-mp="3lt74enpyzlso">
            Aprende exactamente qué hacer en cada etapa del tratamiento para
            reducir refinamientos, evitar errores clínicos y lograr resultados
            más predecibles desde tu próximo caso.
          </p>
        </motion.div>

        {/* mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-7 flex justify-center" data-id="element-138" data-mp="269zivui4kzox">
          <img src="https://cdn.magicpatterns.com/uploads/uz7HPgBDQvwzmsDwayCgt4/Diseno_sin_titulo.png" alt="Sistema Maestro de Planificación con Alineadores — Biblioteca clínica de 6 tomos y 5 bonos" className="h-auto w-full max-w-[30rem] rounded-2xl drop-shadow-2xl animate-floaty sm:max-w-[36rem] lg:max-w-[42rem]" data-id="element-139" data-mp="2g0c1hh6dqisf" />
        </motion.div>

        {/* CTA */}
        <div id="hero-cta-anchor" className="mx-auto mt-2 max-w-md" data-id="element-140" data-mp="un9a5okh8lfo">
          <CtaButton label="Quiero acceder al Sistema Maestro" data-id="element-141" data-mp="zlkl62mid1zh" />
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5" data-id="element-142" data-mp="zlsx9sat439m">
            {badges.map(b => <span key={b} className="inline-flex items-center gap-1 text-xs font-500 text-white/60" data-id="element-143" data-mp="3vhp61z9d0gr1">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-[#2196f3]" data-id="element-144" data-mp="e88xa4a14k5j" />
                {b}
              </span>)}
          </div>
        </div>
      </div>

      {/* stats bar */}
      <div className="relative border-t border-white/10 bg-[#0a1a34]" data-id="element-145" data-mp="3hrbttkpfqfvw">
        <div className="mx-auto grid max-w-lg grid-cols-2 gap-px sm:max-w-2xl sm:grid-cols-4 lg:max-w-5xl" data-id="element-146" data-mp="3crpjbj0zrdqs">
          {stats.map(s => <div key={s.l} className="flex flex-col items-center px-3 py-5 text-center" data-id="element-147" data-mp="3rhmzpcsoiz5f">
              <span className="font-head text-2xl font-800 text-[#2196f3] sm:text-3xl" data-id="element-148" data-mp="3mniscsfi4p3t">
                {s.n}
              </span>
              <span className="mt-1 text-[11px] font-600 uppercase leading-tight tracking-wide text-white/55 sm:text-xs" data-id="element-149" data-mp="2u17qzfk2mk5y">
                {s.l}
              </span>
            </div>)}
        </div>
      </div>
    </header>;
}